export enum GUIDE_STEP_SETTING_FIELDS {
  PARAMETER = "parameter",
  TEXT = "text",
  NUMBER = "number",
  UNIT = "unit",
}
